import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import { RouterModule } from '@angular/router';
@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule
],
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class AuditComponent implements OnInit {
  constructor(
    private router: Router
  ){}
  
  ngOnInit(): void {
  }

  ngDoCheck(): void {
    if(this.router.url == '/audit'){
      this.router.navigate(['audit/menu']);
    }
  }
}